import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components/macro';

export interface NewsItemProps {
  className?: string;
  title: React.ReactNode;
  time: string;
  isNew?: boolean;
}

export function NewsItem(props: NewsItemProps) {
  return (
    <Root className={classNames('news-item', props.className)}>
      <div className="news-item-body">
        <div className="news-item-meta is-flex is-margin-bottom-1">
          {props.isNew ? <p className="tag is-primary">NEW</p> : <span />}
          <p className="news-item-date is-size-7">
            <time>{props.time}</time>
          </p>
        </div>
        <p className="m-card_text">{props.title}</p>
      </div>
    </Root>
  );
}

const Root = styled.li``;

